import { styledComponent } from '@hermes/web-components'
import NextImage from 'next/image'

export const CardContainer = styledComponent('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  max-width: 162px;
  cursor: pointer;
  @media (max-width: 768px) {
  max-width: 132px;
  }
  `

export const CustomRound = styledComponent('span')<{ gradient: string }>`
  position: relative;
  width: 163px;
  height: 163px;
  border-radius: 50%;
  background-color: #f4f7fd;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0;
  overflow: hidden;
  border: 1px solid #AABDF3;
  transition: background-color 0.3s ease-in-out;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    padding: 2px;
    border-radius: 50%;
    background: ${({ gradient }) => gradient};
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    transition: opacity 0.3s ease-in-out;
    opacity: 0;
    z-index: -1;
  }

  &:hover::before {
    opacity: 1;
  }

  &:hover {
    background-color: transparent;
  }

  @media (max-width: 768px) {
    width: 132px;
    height: 132px;
  }
`

export const CardText = styledComponent('a')`
  color: #2A2461;
  font-weight: 500;
  font-size: 15px;
  text-align: center;
  text-decoration: none;
  `

export const CustomImage = styledComponent(NextImage)<{ isAltImage: boolean }>`
  object-fit: ${({ isAltImage }) => (isAltImage ? '' : 'contain')};
  `
